module.exports = __webpack_public_path__ + "img/i_m.7977818c.jpg";